var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 351,
    viewBox: "0 0 193 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.3137 19.6593C85.3137 8.79349 76.5182 0 65.6639 0C54.8095 0 46 8.79349 46 19.6593C46 29.503 53.2409 37.6244 62.6807 39.0666L65.6499 44.2195L68.6191 39.0666C78.0728 37.6244 85.3137 29.489 85.3137 19.6593Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5241 30.8748C59.0955 30.8748 53.8574 25.6379 53.8574 19.2109C53.8574 12.7838 59.0955 7.54688 65.5241 7.54688C71.9527 7.54688 77.1908 12.7838 77.1908 19.2109C77.1908 25.6379 71.9667 30.8748 65.5241 30.8748ZM65.5241 8.91911C59.8378 8.91911 55.23 13.5399 55.23 19.2109C55.23 24.8818 59.8518 29.5026 65.5241 29.5026C71.1964 29.5026 75.8182 24.8818 75.8182 19.2109C75.8182 13.5399 71.2104 8.91911 65.5241 8.91911Z",
    fill: "#22C55E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4251 25.4867C65.2291 25.4867 65.033 25.4027 64.9069 25.2347L60.2431 19.6198C60.005 19.3257 60.047 18.9056 60.3271 18.6536C60.6072 18.4155 61.0414 18.4576 61.2935 18.7376L65.2571 23.5124L69.7389 13.5287C69.8929 13.1787 70.2991 13.0386 70.6352 13.1787C70.9854 13.3607 71.1394 13.7668 70.9854 14.1028L66.0554 25.0807C65.9574 25.2907 65.7613 25.4447 65.5232 25.4727C65.4812 25.4867 65.4531 25.4867 65.4251 25.4867Z",
    fill: "#22C55E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 273.016H73.8976V326.997H0V273.016Z",
    fill: "#E89E3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98047 279.953H31.2433V315.227H8.98047V279.953Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 218.992H73.8976V273.02H0V218.992Z",
    fill: "#E89E3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98047 225.922H31.2433V261.242H8.98047V225.922Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6934 249.469H28.5775V257.194H11.6934V249.469Z",
    fill: "#AABEDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 165.008H73.8976V218.989H0V165.008Z",
    fill: "#E89E3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98047 171.945H31.2433V207.219H8.98047V171.945Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6934 195.445H28.5775V203.17H11.6934V195.445Z",
    fill: "#AABEDC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 110.984H73.8976V165.012H0V110.984Z",
    fill: "#E89E3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98047 117.914H31.2433V153.235H8.98047V117.914Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6934 141.461H28.5775V149.186H11.6934V141.461Z",
    fill: "#AABEDC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 57H73.8976V110.981H0V57Z",
    fill: "#E89E3F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98047 63.9375H31.2433V99.2115H8.98047V63.9375Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6934 87.4375H28.5775V95.209H11.6934V87.4375Z",
    fill: "#AABEDC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83594 273.016H73.1032V326.997H3.83594V273.016Z",
    fill: "#F8D059"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1016 273.016H146.999V326.997H73.1016V273.016Z",
    fill: "#E89E3F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6699 273.016H48.22V280.601H28.6699V273.016Z",
    fill: "#E19B3B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83594 218.992H73.1032V273.02H3.83594V218.992Z",
    fill: "#F8D059"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1016 218.992H146.999V273.02H73.1016V218.992Z",
    fill: "#E89E3F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6699 218.992H48.22V226.624H28.6699V218.992Z",
    fill: "#E19B3B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6699 265.391H48.22V273.022H28.6699V265.391Z",
    fill: "#E19B3B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.082 225.922H104.345V261.242H82.082V225.922Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7949 249.469H101.679V257.194H84.7949V249.469Z",
    fill: "#AABEDC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.082 282.375H104.345V317.649H82.082V282.375Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7949 305.875H101.679V313.646H84.7949V305.875Z",
    fill: "#AABEDC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83594 165.008H73.1032V218.989H3.83594V165.008Z",
    fill: "#F8D059"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1016 165.008H146.999V218.989H73.1016V165.008Z",
    fill: "#E89E3F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6699 165.008H48.22V172.593H28.6699V165.008Z",
    fill: "#E19B3B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6699 211.406H48.22V218.992H28.6699V211.406Z",
    fill: "#E19B3B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.082 171.945H104.345V207.219H82.082V171.945Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7949 195.445H101.679V203.17H84.7949V195.445Z",
    fill: "#AABEDC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83594 110.984H73.1032V165.012H3.83594V110.984Z",
    fill: "#F8D059"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1016 110.984H146.999V165.012H73.1016V110.984Z",
    fill: "#E89E3F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6699 110.984H48.22V118.616H28.6699V110.984Z",
    fill: "#E19B3B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6699 157.422H48.22V165.007H28.6699V157.422Z",
    fill: "#E19B3B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.082 117.914H104.345V153.235H82.082V117.914Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7949 141.461H101.679V149.186H84.7949V141.461Z",
    fill: "#AABEDC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83594 57H73.1032V110.981H3.83594V57Z",
    fill: "#F8D059"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1016 57H146.999V110.981H73.1016V57Z",
    fill: "#E89E3F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6699 57H48.22V64.5853H28.6699V57Z",
    fill: "#E19B3B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6699 103.398H48.22V110.984H28.6699V103.398Z",
    fill: "#E19B3B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.082 63.9375H104.345V99.2115H82.082V63.9375Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7949 87.4375H101.679V95.209H84.7949V87.4375Z",
    fill: "#AABEDC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8976 109.07H0V112.886H73.8976V109.07Z",
    fill: "#E89E3F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1016 112.887V109.117H146.999V112.887H73.1016Z",
    fill: "#BC7833"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8976 162.773H0V166.543H73.8976V162.773Z",
    fill: "#E89E3F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1016 166.543V162.773H146.999V166.543H73.1016Z",
    fill: "#BC7833"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8976 216.43H0V220.199H73.8976V216.43Z",
    fill: "#E89E3F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1016 220.246V216.43H146.999V220.246H73.1016Z",
    fill: "#BC7833"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8976 270.086H0V273.855H73.8976V270.086Z",
    fill: "#E89E3F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1016 273.902V270.086H146.999V273.902H73.1016Z",
    fill: "#BC7833"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8976 54H0V57.8159H73.8976V54Z",
    fill: "#E89E3F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1016 57.8163V54.0469H146.999V57.8163H73.1016Z",
    fill: "#BC7833"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M128.827 116.19C130.63 104.98 131.761 94.1937 131.761 94.1937C130.326 85.11 125.765 83.9688 125.765 83.9688C122.279 87.1255 119.612 95.5742 117.662 104.566C121.304 108.523 124.735 112.683 128.827 116.19Z",
    fill: "#F22929"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M117.311 108.844C116.005 117.44 115.407 124.25 115.407 124.25C113.467 136.702 112.014 175.817 112.014 175.817C115.398 179.553 118.967 176.756 118.967 176.756C123.685 149.679 125.772 129.404 125.772 129.404C126.674 124.223 127.189 121.627 127.906 118.995C124.144 115.94 120.677 112.359 117.311 108.844Z",
    fill: "#FFAF82"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M128.064 120.704C128.33 119.213 128.579 117.694 128.827 116.194C124.744 112.688 121.313 108.528 117.671 104.57C117.285 106.374 116.917 108.196 116.586 110.01C119.621 114.28 124.109 117.556 128.064 120.704Z",
    fill: "#E4BE00"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M166.764 27.8011C158.257 18.0455 143.11 17.1896 134.271 26.6507C131.77 29.3288 129.792 32.8169 129.121 37.3542C126.675 53.681 136.874 88.5619 136.874 88.5619H166.341C166.341 88.5619 176.752 41.5694 168.907 30.5253C168.199 29.5313 167.491 28.6294 166.764 27.8011Z",
    fill: "#32324C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M123.832 183.487C123.796 171.679 126.711 163.755 126.711 163.755C145.666 162.531 175.464 163.755 175.464 163.755C175.501 163.865 175.547 163.985 175.584 164.095C175.584 164.095 177.598 172.645 176.853 183.487C158.422 194.908 140.654 194.154 123.832 183.487Z",
    fill: "#32324C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M176.918 183.496C176.918 183.496 178.454 246.172 177.341 260.013L177.626 332.941L165.569 331.662C165.182 294.029 158.864 276.69 161.89 259.774C156.151 237.125 153.852 210.499 153.695 189.405C153.686 189.405 164.787 183.174 176.918 183.496Z",
    fill: "#32324C"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M165.155 331.034C165.716 326.266 170.103 323.855 174.407 325.254C178.61 326.616 178.794 333.749 178.794 333.749C178.794 333.749 183.779 338.617 184.542 346.864C184.56 347.048 184.579 347.232 184.597 347.425C184.698 348.953 183.576 350.287 182.068 350.471C174.453 351.373 167.114 351.134 160.087 349.514C158.606 349.174 157.641 347.747 157.908 346.238C157.917 346.183 157.926 346.127 157.935 346.063C158.579 342.464 159.866 335.866 164.419 333.602L165.155 331.034Z",
    fill: "#181823"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M166.59 336.62L166.25 335.727C166.517 335.626 172.918 333.224 177.351 336.417L176.79 337.191C172.771 334.301 166.655 336.602 166.59 336.62Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M167.381 336.536C167.252 337.116 166.682 337.484 166.102 337.365C165.523 337.236 165.155 336.665 165.274 336.085C165.403 335.505 165.973 335.137 166.553 335.257C167.132 335.386 167.509 335.956 167.381 336.536Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M178.168 336.778C178.039 337.358 177.469 337.726 176.889 337.607C176.31 337.478 175.942 336.907 176.062 336.327C176.19 335.748 176.761 335.379 177.34 335.499C177.929 335.628 178.296 336.199 178.168 336.778Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M166.819 333.932L166.479 333.04C166.745 332.939 173.146 330.536 177.579 333.73L177.018 334.503C172.999 331.613 166.883 333.905 166.819 333.932Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M167.609 333.849C167.48 334.428 166.91 334.797 166.331 334.677C165.751 334.548 165.383 333.978 165.503 333.398C165.623 332.818 166.202 332.45 166.781 332.569C167.37 332.698 167.738 333.269 167.609 333.849Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M178.406 334.091C178.277 334.671 177.707 335.039 177.128 334.919C176.548 334.79 176.18 334.22 176.3 333.64C176.429 333.06 176.999 332.692 177.578 332.812C178.158 332.94 178.526 333.511 178.406 334.091Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M166.459 339.307L166.119 338.415C166.386 338.314 172.787 335.911 177.22 339.105L176.659 339.878C172.64 336.988 166.524 339.28 166.459 339.307Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M167.259 339.216C167.131 339.796 166.561 340.164 165.981 340.044C165.402 339.915 165.034 339.345 165.153 338.765C165.282 338.185 165.852 337.817 166.432 337.937C167.011 338.065 167.379 338.636 167.259 339.216Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M178.047 339.466C177.918 340.046 177.348 340.414 176.768 340.294C176.189 340.165 175.821 339.595 175.941 339.015C176.069 338.435 176.639 338.067 177.219 338.187C177.798 338.315 178.166 338.886 178.047 339.466Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M174.885 328.368C174.885 328.368 171.712 327.107 168.907 328.332C168.631 328.902 168.557 329.74 168.806 330.531C168.806 330.531 172.54 330.108 174.857 330.669C174.857 330.669 175.363 329.372 174.885 328.368Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M182.058 350.471C174.443 351.373 167.104 351.134 160.077 349.514C158.597 349.173 157.631 347.747 157.898 346.237C157.907 346.182 157.916 346.127 157.925 346.062C162.294 347.507 172.521 350.002 184.541 346.872C184.56 347.056 184.578 347.241 184.597 347.434C184.698 348.962 183.576 350.296 182.058 350.471Z",
    fill: "#32324C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M123.988 183.496C123.988 183.496 122.452 246.172 123.565 260.013L123.28 332.941L135.337 331.662C135.723 294.029 142.041 276.69 139.016 259.774C144.754 237.125 147.054 210.499 147.21 189.405C147.219 189.405 136.128 183.174 123.988 183.496Z",
    fill: "#32324C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M135.751 331.034C135.19 326.266 130.803 323.855 126.499 325.254C122.296 326.616 122.112 333.749 122.112 333.749C122.112 333.749 117.128 338.617 116.364 346.864C116.346 347.048 116.327 347.232 116.309 347.425C116.208 348.953 117.33 350.287 118.838 350.471C126.453 351.373 133.792 351.134 140.819 349.514C142.3 349.174 143.265 347.747 142.999 346.238C142.989 346.183 142.98 346.127 142.971 346.063C142.327 342.464 141.04 335.866 136.487 333.602L135.751 331.034Z",
    fill: "#181823"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M134.317 336.62L134.657 335.727C134.391 335.626 127.99 333.224 123.557 336.417L124.118 337.191C128.137 334.301 134.262 336.602 134.317 336.62Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M133.526 336.536C133.655 337.116 134.225 337.484 134.805 337.365C135.384 337.236 135.752 336.665 135.633 336.085C135.513 335.505 134.934 335.137 134.354 335.257C133.775 335.386 133.407 335.956 133.526 336.536Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M122.739 336.778C122.867 337.358 123.438 337.726 124.017 337.607C124.596 337.478 124.964 336.907 124.845 336.327C124.716 335.748 124.146 335.379 123.566 335.499C122.978 335.628 122.61 336.199 122.739 336.778Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M134.087 333.932L134.427 333.04C134.16 332.939 127.759 330.536 123.326 333.73L123.887 334.503C127.906 331.613 134.022 333.905 134.087 333.932Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M133.295 333.849C133.424 334.428 133.994 334.797 134.574 334.677C135.153 334.548 135.521 333.978 135.401 333.398C135.273 332.818 134.702 332.45 134.123 332.569C133.534 332.698 133.166 333.269 133.295 333.849Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M122.508 334.091C122.637 334.671 123.207 335.039 123.786 334.919C124.366 334.79 124.734 334.22 124.614 333.64C124.485 333.06 123.915 332.692 123.336 332.812C122.747 332.94 122.379 333.511 122.508 334.091Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M134.444 339.307L134.784 338.415C134.518 338.314 128.117 335.911 123.684 339.105L124.245 339.878C128.264 336.988 134.38 339.28 134.444 339.307Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M133.655 339.216C133.783 339.796 134.354 340.164 134.933 340.044C135.512 339.915 135.88 339.345 135.761 338.765C135.632 338.185 135.062 337.817 134.482 337.937C133.894 338.065 133.526 338.636 133.655 339.216Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M122.857 339.466C122.985 340.046 123.555 340.414 124.135 340.294C124.714 340.165 125.082 339.595 124.963 339.015C124.834 338.435 124.264 338.067 123.684 338.187C123.105 338.315 122.737 338.886 122.857 339.466Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M126.022 328.368C126.022 328.368 129.195 327.107 132 328.332C132.276 328.902 132.349 329.74 132.101 330.531C132.101 330.531 128.367 330.108 126.049 330.669C126.049 330.669 125.553 329.372 126.022 328.368Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M118.847 350.471C126.462 351.373 133.802 351.134 140.828 349.514C142.309 349.173 143.274 347.747 143.008 346.237C142.999 346.182 142.989 346.127 142.98 346.062C138.612 347.507 128.385 350.002 116.364 346.872C116.346 347.056 116.327 347.241 116.309 347.434C116.208 348.962 117.339 350.296 118.847 350.471Z",
    fill: "#32324C"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M170.368 127.943L176.328 164.499C176.328 164.499 164.252 170.647 150.429 170.647C135.677 170.647 125.754 164.499 125.754 164.499L131.714 127.943L130.996 113.328L130.932 112.049C130.463 111.699 130.058 111.285 129.709 110.825C126.444 106.628 127.786 98.6673 127.786 98.6673L125.763 83.9695L144.644 75.9349L156.775 75.7969L176.438 83.1228L174.305 98.6673C174.305 98.6673 175.804 105.331 173.302 109.886C172.888 110.641 172.364 111.331 171.711 111.929V111.948L170.368 127.943Z",
    fill: "#F22929"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M167.83 113.516C167.83 113.516 154.495 122.949 135.301 114.095C135.292 114.086 153.226 118.918 167.83 113.516Z",
    fill: "#BC2327"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M136.874 49.7201C136.874 49.7201 133.757 46.6645 131.264 48.6617C128.321 51.0177 131.402 59.4849 136.617 58.5921L136.874 49.7201Z",
    fill: "#FFA378"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M135.826 56.2527C135.623 56.2343 135.449 56.0871 135.403 55.8754C134.538 52.0008 132.11 51.6786 132.092 51.6786C131.825 51.651 131.632 51.4117 131.669 51.1448C131.696 50.8779 131.954 50.6939 132.202 50.7215C132.331 50.7399 135.338 51.1356 136.35 55.6729C136.405 55.9306 136.239 56.1975 135.982 56.2527C135.927 56.2527 135.872 56.2527 135.826 56.2527Z",
    fill: "#F88968"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M132.487 54.1158C132.404 54.1066 132.322 54.079 132.257 54.0237C132.037 53.8673 131.991 53.5636 132.147 53.3427C132.184 53.2967 133.011 52.1554 134.612 52.3211C134.621 52.3211 134.63 52.3211 134.649 52.3211C134.915 52.3487 135.108 52.588 135.081 52.8549C135.053 53.1218 134.814 53.3059 134.547 53.2875C134.538 53.2875 134.529 53.2875 134.52 53.2875C133.471 53.177 132.947 53.8949 132.947 53.9041C132.828 54.0605 132.653 54.1342 132.487 54.1158Z",
    fill: "#F88968"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M163.473 49.7201C163.473 49.7201 166.59 46.6645 169.083 48.6617C172.026 51.0177 168.945 59.4849 163.73 58.5921L163.473 49.7201Z",
    fill: "#FFA378"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M164.521 56.2527C164.724 56.2343 164.898 56.0871 164.944 55.8754C165.809 52.0008 168.237 51.6786 168.255 51.6786C168.522 51.651 168.715 51.4117 168.678 51.1448C168.651 50.8779 168.393 50.6939 168.145 50.7215C168.016 50.7399 165.009 51.1356 163.997 55.6729C163.942 55.9306 164.107 56.1975 164.365 56.2527C164.42 56.2527 164.475 56.2527 164.521 56.2527Z",
    fill: "#F88968"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M167.86 54.1158C167.943 54.1066 168.025 54.079 168.09 54.0237C168.31 53.8673 168.356 53.5636 168.2 53.3427C168.163 53.2967 167.336 52.1554 165.735 52.3211C165.726 52.3211 165.717 52.3211 165.699 52.3211C165.432 52.3487 165.239 52.588 165.266 52.8549C165.294 53.1218 165.533 53.3059 165.8 53.2875C165.809 53.2875 165.818 53.2875 165.827 53.2875C166.876 53.177 167.4 53.8949 167.4 53.9041C167.52 54.0605 167.694 54.1342 167.86 54.1158Z",
    fill: "#F88968"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M156.869 67.8359L156.649 71.9314L156.373 77.0669C156.373 77.0669 156.253 87.0158 151.094 87.0158C145.778 87.0158 145.226 77.6744 145.226 77.6744L145.042 75.4011L144.426 67.8359H156.869Z",
    fill: "#FFAF82"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M156.869 67.8359L156.649 71.9314C154.736 73.3672 150.192 76.1926 145.042 75.4011L144.426 67.8359H156.869Z",
    fill: "#F88968"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M166.783 46.4915C166.737 46.9792 166.692 47.4854 166.636 47.9916C165.56 58.5295 162.305 71.8376 150.698 71.8376C144.389 71.8376 140.213 67.9538 137.491 62.7354C137.427 62.5974 137.344 62.4685 137.289 62.3305C136.82 61.4101 136.406 60.453 136.029 59.4774C135.247 57.4251 134.64 55.2715 134.171 53.1363C134.162 53.0719 134.144 53.0075 134.125 52.943C134.07 52.6945 134.033 52.4645 133.978 52.2252C133.84 51.5257 133.72 50.8723 133.619 50.3109C133.546 49.8231 133.463 49.3813 133.417 49.0224C133.316 48.2677 133.224 47.5406 133.15 46.8228C132.111 37.058 139.68 28.462 149.493 28.3516H150.367C157.66 28.4436 163.73 33.2018 165.937 39.6625C166.204 40.4356 166.406 41.2363 166.563 42.0554C166.839 43.4635 166.921 44.9637 166.783 46.4915Z",
    fill: "#FFAF82"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M166.986 42.0573C166.986 42.0573 165.901 41.5879 164.816 41.9101C158.736 43.6955 146.091 40.6952 140.517 37.2439C140.517 37.2439 139.018 42.1493 136.066 46.751C136.066 46.751 137.087 55.8992 137.298 62.3324C136.829 61.412 136.415 60.4549 136.038 59.4793C135.257 57.427 134.65 55.2734 134.181 53.1382C134.171 53.0738 134.153 53.0093 134.135 52.9449C134.079 52.6964 134.043 52.4664 133.987 52.2271C133.849 51.5276 133.73 50.8742 133.629 50.3128C133.555 49.825 133.472 49.3832 133.426 49.0243C133.325 48.2696 132.847 47.2112 132.764 46.4933C131.725 36.7285 139.598 27.7276 149.401 27.6172H150.993C158.286 27.7092 163.969 33.0748 166.177 39.5448C166.471 40.2995 166.83 41.2382 166.986 42.0573Z",
    fill: "#32324C"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M167.087 46.4484C167.041 46.9361 166.7 47.4975 166.645 48.0037C165.275 47.2214 164.907 43.9634 164.815 41.9203C164.76 40.9171 164.778 40.2085 164.778 40.2085C164.778 40.2085 164.852 39.8495 165.965 39.6562C166.231 40.4293 166.7 41.1932 166.857 42.0123C167.114 43.4388 167.216 44.9114 167.087 46.4484Z",
    fill: "#32324C"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M145.612 50.6288C145.63 51.8253 145.106 52.8008 144.453 52.81C143.8 52.8192 143.257 51.8529 143.239 50.6656C143.22 49.4692 143.745 48.4936 144.398 48.4844C145.06 48.4752 145.602 49.4416 145.612 50.6288Z",
    fill: "#32324C"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M139.725 46.474C139.725 46.474 140.801 44.3112 143.495 43.9523C145.574 43.6762 146.944 44.0259 147.662 44.302C148.002 44.4401 148.177 44.8174 148.048 45.1672C147.91 45.5537 147.459 45.7286 147.091 45.5445C145.767 44.8634 142.714 43.805 139.725 46.474Z",
    fill: "#32324C"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M156.262 50.5978C156.244 51.7942 156.768 52.7698 157.421 52.779C158.074 52.7882 158.617 51.8218 158.635 50.6346C158.653 49.4381 158.129 48.4626 157.476 48.4534C156.823 48.435 156.281 49.4013 156.262 50.5978Z",
    fill: "#32324C"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M162.166 46.4506C162.166 46.4506 161.09 44.2878 158.396 43.9289C156.317 43.6528 154.947 44.0025 154.229 44.2786C153.889 44.4166 153.714 44.794 153.843 45.1437C153.981 45.5303 154.432 45.7051 154.8 45.5211C156.124 44.8308 159.177 43.7724 162.166 46.4506Z",
    fill: "#32324C"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M150.928 59.1445C150.809 59.1169 150.698 59.0433 150.615 58.9421C150.386 58.6752 150.422 58.2794 150.68 58.0493L152.731 56.2915L151.057 55.6381C150.827 55.546 150.671 55.3343 150.661 55.0951L150.303 50.0332C150.275 49.6835 150.542 49.3889 150.882 49.3613C151.232 49.3337 151.526 49.6006 151.554 49.9412L151.885 54.6073L154.165 55.5C154.368 55.5828 154.524 55.7669 154.561 55.9786C154.598 56.1995 154.515 56.4203 154.349 56.5584L151.498 58.9973C151.333 59.163 151.121 59.1998 150.928 59.1445Z",
    fill: "#F88968"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M151.57 63.6142C149.851 63.743 147.846 63.4577 145.868 62.1784C145.574 61.9852 145.491 61.5986 145.684 61.3041C145.878 61.0096 146.264 60.9268 146.558 61.12C150.89 63.9271 155.59 61.12 155.636 61.0924C155.93 60.9084 156.316 61.0096 156.5 61.3041C156.684 61.5986 156.592 61.9852 156.289 62.1692C156.151 62.252 154.201 63.4209 151.57 63.6142Z",
    fill: "#F88968"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M151.525 66.8229C149.557 66.9977 148.269 66.0682 148.196 66.013C147.92 65.8013 147.855 65.4148 148.067 65.1295C148.269 64.8534 148.665 64.7889 148.941 65.0006C149.023 65.0558 150.752 66.2615 153.208 65.0466C153.521 64.8902 153.898 65.019 154.054 65.3319C154.21 65.6448 154.082 66.0222 153.769 66.1786C152.951 66.5744 152.196 66.7677 151.525 66.8229Z",
    fill: "#F88968"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M110.791 177.316C110.791 177.316 109.228 186.998 110.497 192.474C111.766 197.95 113.357 201.493 114.286 200.812C115.215 200.131 112.851 188.774 114.074 188.084C117.054 186.381 116.466 193.302 117.891 192.694C119.317 192.087 119.114 177.481 119.114 177.481C119.114 177.481 117.404 172.751 114.562 173.229C111.72 173.699 110.791 177.316 110.791 177.316Z",
    fill: "#FFAF82"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M138.51 154.493H165.797C166.653 154.493 167.342 153.802 167.342 152.946V113.491C167.342 112.636 166.653 111.945 165.797 111.945H138.51C137.655 111.945 136.965 112.636 136.965 113.491V152.946C136.965 153.802 137.655 154.493 138.51 154.493Z",
    fill: "#308194"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M159.259 138.953L150.118 140.729C150.118 140.729 141.518 137.398 140.121 137.287C138.723 137.177 134.428 136.753 133.784 137.287C133.14 137.821 132.818 139.008 133.03 139.542C133.241 140.076 134.538 140.729 134.538 140.729C134.538 140.729 132.745 141.806 132.57 142.662C132.395 143.518 132.57 144.595 132.57 144.595L134.648 146.426C134.648 146.426 133.269 148.506 134.069 149.509C134.869 150.512 136.874 152.022 136.874 152.022L137.012 150.19C137.012 150.19 145.712 150.835 148.619 148.791L154.229 148.202L159.259 138.953Z",
    fill: "#FFAF82"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M185.608 105.898C183.695 110.896 179.924 114.642 175.537 117.439L178.287 125.483C178.655 126.965 177.873 128.493 176.466 129.073L152.352 140.282L153.814 148.188C153.814 148.188 190.684 141.782 192.009 137.006C192.754 134.365 189.581 119.446 185.608 105.898Z",
    fill: "#FFAF82"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M174.158 113.401L175.538 117.45C179.925 114.652 183.695 110.906 185.608 105.909C185.121 104.252 184.624 102.623 184.119 101.031C181.111 105.559 177.662 109.287 174.158 113.401Z",
    fill: "#E4BE00"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M176.209 83.0412C176.209 83.0412 175.124 82.1116 173.542 90.0634C171.951 98.0151 172.769 109.335 172.769 109.335L174.158 113.403C177.662 109.289 181.12 105.562 184.127 101.034C181.35 92.2722 178.388 84.8819 176.209 83.0412Z",
    fill: "#F22929"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M148.323 86.8672H147.68V109.066H148.323V86.8672Z",
    fill: "#BC2327"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M151.285 111.261H150.604C142.254 111.316 134.593 112.614 130.997 113.332L130.932 112.053C130.463 111.703 130.058 111.289 129.709 110.828C132.376 110.23 140.709 108.564 150.595 108.5H151.055C151.405 109.42 151.221 110.341 151.285 111.261Z",
    fill: "#D9DADA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M173.312 109.322L173.303 109.884C172.889 110.638 172.365 111.329 171.712 111.927V111.945C168.796 111.697 161.779 111.218 151.285 111.255C151.23 110.528 150.816 108.494 150.881 108.494L150.752 86.8384L151.184 87.1513L153.52 86.0469L153.465 108.494C166.276 108.531 173.238 109.313 173.312 109.322Z",
    fill: "#E4BE00"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M161.549 99.4884C163.416 99.4884 164.933 98.43 164.933 97.1231C164.933 95.8162 163.416 94.7578 161.549 94.7578C159.682 94.7578 158.164 95.8162 158.164 97.1231C158.164 98.43 159.682 99.4884 161.549 99.4884Z",
    fill: "#55B2D1"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M160.684 97.9273C161.76 97.9273 162.634 97.3199 162.634 96.5652C162.634 95.8106 161.76 95.2031 160.684 95.2031C159.608 95.2031 158.734 95.8106 158.734 96.5652C158.734 97.3199 159.608 97.9273 160.684 97.9273Z",
    fill: "#C1D2DB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M144.756 88.5379L145.105 90.7928L147.533 87.0194L150.982 87.047L149.511 86.0622L146.283 84.2031L144.756 88.5379Z",
    fill: "#BC2327"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M151.193 87.1539L147.284 85.4788L145.104 90.7892C145.104 90.7892 140.138 85.6629 140.837 77.5179L145.077 75.7969C145.077 75.7969 144.424 82.3773 151.193 87.1539Z",
    fill: "#F44D4D"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M157.255 88.5379L156.905 90.7928L154.486 87.0194L151.424 87.047L152.739 86.2095L155.728 84.2031L157.255 88.5379Z",
    fill: "#BC2327"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M143.92 99.4688H133.619V102.8H143.92V99.4688Z",
    fill: "#EDEDED"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M143.92 99.4315V99.4775H133.619V99.4315C133.619 98.7412 134.042 98.1798 134.557 98.1798H142.991C143.497 98.1706 143.92 98.7412 143.92 99.4315Z",
    fill: "#E4BE00"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M143.919 102.797V102.843C143.919 103.533 143.496 104.095 142.981 104.095H134.547C134.032 104.095 133.609 103.533 133.609 102.843V102.797H143.919Z",
    fill: "#E4BE00"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M143.736 102.975H133.794C133.693 102.975 133.619 102.892 133.619 102.8C133.619 102.708 133.702 102.625 133.794 102.625H143.736C143.837 102.625 143.911 102.708 143.911 102.8C143.911 102.892 143.837 102.975 143.736 102.975Z",
    fill: "#D82727"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M143.736 99.5685H133.794C133.693 99.5685 133.619 99.4856 133.619 99.3936C133.619 99.3016 133.702 99.2188 133.794 99.2188H143.736C143.837 99.2188 143.911 99.3016 143.911 99.3936C143.911 99.4856 143.837 99.5685 143.736 99.5685Z",
    fill: "#D82727"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M149.593 90.6779C149.961 90.6779 150.265 90.3558 150.265 89.9601C150.265 89.5643 149.961 89.2422 149.593 89.2422C149.225 89.2422 148.922 89.5643 148.922 89.9601C148.922 90.3558 149.225 90.6779 149.593 90.6779Z",
    fill: "#CC9D83"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M149.593 94.9123C149.961 94.9123 150.265 94.5902 150.265 94.1944C150.265 93.7987 149.961 93.4766 149.593 93.4766C149.225 93.4766 148.922 93.7987 148.922 94.1944C148.922 94.5902 149.225 94.9123 149.593 94.9123Z",
    fill: "#CC9D83"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M149.593 99.1545C149.961 99.1545 150.265 98.8324 150.265 98.4366C150.265 98.0409 149.961 97.7188 149.593 97.7188C149.225 97.7188 148.922 98.0409 148.922 98.4366C148.922 98.8324 149.225 99.1545 149.593 99.1545Z",
    fill: "#CC9D83"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M151.193 87.1521L155.102 85.4771L157.282 90.7875C157.282 90.7875 161.31 85.3299 160.611 77.1849L156.408 75.7031C156.399 75.7123 157.254 82.0627 151.193 87.1521Z",
    fill: "#F44D4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4);
export default __webpack_public_path__ + "static/media/card_4.20f8f5f4210249d7640d2071edc6ffb5.svg";
export { ForwardRef as ReactComponent };